<template>
    <div class="home-box">
      <PageTitle :title="'Add Gl Sub Headers'" class="py-5"></PageTitle>
      <v-row align="center">
        <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
          <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
        </v-overlay>
  
        <div class="col-md-12 home-tabs-body">
          <AddGlSub></AddGlSub>
        </div>
      </v-row>
    </div>
  </template>
  
  <script>
  import AddGlSub from "@/components/GlSubHeaders/AddGlSubForm";
  import PageTitle from "@/components/shared/PageTitle";
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "InventoryCreateForm",
    components: {
      PageTitle,
      AddGlSub
    },
    data: function () {
      return {
        editMode: false,
        loading: false
      };
    },
    computed: {
      ...mapGetters({
        profile: "profile",
      }),
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
      this.$store.dispatch("settings/getCompanySettings");
    },
  
    watch: {
    }
  };
  </script>
  